export const VERSION_NUMBER = '18.0.0.5964';

// If we only have a constant in here TS doens't recognise it as a module
// We could do something useful in this class to make it less silly...
export class AppVersion { }
